import { useFlags } from 'launchdarkly-react-client-sdk';
import isNumber from 'lodash/isNumber';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Scores, SetOfAssessments } from 'src/modules/assessments/components/SetOfAssessments';
import { FlowType } from 'src/modules/assessments/models/assessments';
import { BrandWrapper } from 'src/modules/onboarding/components/BrandWrapper';

export const ReTriageAssessmentPage: React.FC<RouteComponentProps> = ({ history }) => {
    const flags = useFlags();

    const handleAssessmentsSubmit = (scores: Scores) => {
        let qualifiesForTherapy = scores.who5 <= flags.who5ScoreThresholdForTherapy;

        // we may have no access to these scores if user submitted only who5 assessment
        if (isNumber(scores?.phq2) && isNumber(scores?.gad2)) {
            qualifiesForTherapy = qualifiesForTherapy && (scores.phq2 >= 3 || scores.gad2 >= 3);
        }

        const nextPage = qualifiesForTherapy ? '/re-triage-therapy' : '/re-triage-next-steps';

        history.push(nextPage, { previousScore: scores.previousWho5 });
    };

    return (
        <BrandWrapper>
            <SetOfAssessments onSubmit={handleAssessmentsSubmit} flowType={FlowType.RETRIAGE} />
        </BrandWrapper>
    );
};
